<app-navbar></app-navbar>

<main class="profile-page">
  <section class="profile-card">
    <div *ngIf="loading" class="profile-loading">
      <mat-spinner diameter="42"></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">
      <header class="profile-header">
        <div class="profile-icon"><mat-icon>person</mat-icon></div>
        <div>
          <span class="eyebrow">Your profile</span>
          <h1>{{ profile?.firstName || 'Konvac' }} {{ profile?.lastName || 'member' }}</h1>
          <p>{{ profile?.email || currentUser?.email }}</p>
        </div>
      </header>

      <div *ngIf="requiredForAssessment && !profile?.resumeUrl" class="required-notice">
        <mat-icon>info</mat-icon>
        <div>
          <strong>Resume required before starting</strong>
          <p>Upload your resume to continue to your selected assessment.</p>
        </div>
      </div>

      <section class="resume-section">
        <div class="section-heading">
          <div>
            <h2>Resume</h2>
            <p>Add your latest resume to your Konvac profile. PDF, DOC, and DOCX files up to 10 MB are supported.</p>
          </div>
          <span class="resume-status" [class.complete]="profile?.resumeUrl">
            <mat-icon>{{ profile?.resumeUrl ? 'check_circle' : 'pending' }}</mat-icon>
            {{ profile?.resumeUrl ? 'Uploaded' : 'Not added' }}
          </span>
        </div>

        <button *ngIf="profile?.resumeUrl" type="button" class="current-resume" (click)="viewResume()">
          <mat-icon>description</mat-icon>
          <span><strong>Current resume</strong><small>Open uploaded file</small></span>
          <mat-icon>open_in_new</mat-icon>
        </button>

        <label class="file-picker" [class.has-file]="selectedFile">
          <input type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="onFileSelected($event)" [disabled]="uploading">
          <mat-icon>{{ selectedFile ? 'task' : 'upload_file' }}</mat-icon>
          <span>
            <strong>{{ selectedFile?.name || (profile?.resumeUrl ? 'Choose a replacement resume' : 'Choose your resume') }}</strong>
            <small>{{ selectedFile ? 'Ready to upload' : 'Click to select a file' }}</small>
          </span>
        </label>

        <div class="profile-actions">
          <button type="button" class="secondary-button" *ngIf="!requiredForAssessment" (click)="skipForNow()">Back to assessments</button>
          <button type="button" class="primary-button" (click)="uploadResume()" [disabled]="!selectedFile || uploading">
            <mat-spinner *ngIf="uploading" diameter="19"></mat-spinner>
            <mat-icon *ngIf="!uploading">cloud_upload</mat-icon>
            {{ uploading ? 'Uploading…' : (profile?.resumeUrl ? 'Update resume' : 'Upload resume') }}
          </button>
        </div>
      </section>
    </ng-container>
  </section>
</main>

<app-footer></app-footer>
